import { defineStore } from 'pinia';

export const useIssueLocationStore = defineStore({
  id: 'shaftIssueLocation',
  state: () => ({
    location: null,
    formData: null,
    saveAndCreateNewIssue: false
  }),
});
